






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'

@Component({
  name: 'EditCodic',    
  components:{EditBaseFlux}
})
export default class EditCodic extends Vue {
  
  private flux = getDefaultAloFlux()  
  private rows = 27

  onResize() {              
    //@ts-ignore                    
    const rowHeight = this.$refs.codicArea?this.$refs.codicArea.rowHeight:20
    //@ts-ignore    
    this.rows = Math.floor((this.$refs.baseEdit.$el.clientHeight - 280) / rowHeight)
  }

  edit(item:AloFlux) {    
    this.onResize()    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)    
  }    
}
